import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./teacherAccountFormTour.css";

export function startTeacherAccountFormTour({ isEdit = false } = {}) {
  const segments = [
    {
      selector: '[data-tour="teacher-account-form-header"]',
      title: "Tổng quan form",
      description:
        "Đây là form tạo/cập nhật tài khoản giáo viên đối tác. Điền các trường bắt buộc trước: Họ tên, email, chi nhánh và trường (khi tạo mới).",
      side: "bottom",
    },
    {
      selector: '[data-tour="teacher-account-form-personal"]',
      title: "Thông tin cá nhân",
      description:
        "Email cá nhân là tài khoản đăng nhập APP. Tên được chuẩn hóa chữ hoa đầu từ khi rời ô nhập.",
      side: "right",
    },
    {
      selector: '[data-tour="teacher-account-form-org"]',
      title: "Đối tác & tổ chức",
      description:
        "Chọn Chi nhánh trước, sau đó chọn Trường (khách hàng CRM). Màn này chỉ có khi tạo mới.",
      side: "left",
    },
    {
      selector: '[data-tour="teacher-account-form-docquota"]',
      title: "Hạn mức tài liệu",
      description:
        "Thiết lập hạn mức tháng, bonus ban đầu và miễn trừ hạn mức tài liệu.",
      side: "left",
    },
    {
      selector: '[data-tour="teacher-account-form-status"]',
      title: "Trạng thái tài khoản",
      description:
        "Khi sửa tài khoản, có thể bật/tắt trạng thái hoạt động để cho phép hoặc khóa đăng nhập.",
      side: "left",
    },
    {
      selector: '[data-tour="teacher-account-form-devices"]',
      title: "Thiết bị đăng nhập",
      description:
        "Mỗi tài khoản: tối đa 1 máy tính + 1 điện thoại. Quản lý / duyệt thiết bị mới ở màn chi tiết hoặc Đổi thiết bị.",
      side: "left",
    },
    {
      selector: '[data-tour="teacher-account-form-payroll"]',
      title: "Tài khoản nhận lương",
      description:
        "Thông tin ngân hàng là tùy chọn, nhưng nên nhập để đồng bộ chi trả sau này.",
      side: "right",
    },
    {
      selector: '[data-tour="teacher-account-form-footer"]',
      title: "Lưu hồ sơ",
      description:
        "Bấm Lưu hồ sơ để hoàn tất. Khi tạo mới, hệ thống gửi mật khẩu tạm đến email đăng nhập đã nhập.",
      side: "top",
    },
  ];

  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          isEdit
            ? "Tour này giúp bạn rà soát nhanh các khu vực quan trọng khi cập nhật tài khoản giáo viên đối tác."
            : "Tour này giúp bạn tạo nhanh tài khoản giáo viên đối tác đúng luồng.",
        side: "over",
        align: "center",
      },
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Chưa tải đủ vùng giao diện để chạy hướng dẫn. Vui lòng thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "teacher-account-form-tour-popover",
    onPopoverRender: (popover) => {
      popover.wrapper?.setAttribute?.("lang", "vi");
    },
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
